import { proxy } from 'valtio'

export type SelectionCondition = 'macd' | 'tdcc' | 'doubleMa' | 'financialReport'

export const revive_store = proxy({
  stockSelectionType: 'long' as 'long' | 'short',
  stockSelectionCondition: [] as SelectionCondition[],
  stockSymbol: ['2330'] as string[],
})
